import { OrderItem } from "@omni/types/api/cart/bff/shared/orderItem.model";
import { DeliveryType } from "@omni/types/api/product/bff/shared/enums/deliveryType.enum";
import { Fragment } from "react";

import OrderItemStatus from "@/components/Order/shared/OrderItemStatus/orderItemStatus.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type DeliveryPromiseComponentProps = {
    item: OrderItem;
};

const DeliveryPromiseComponent = ({ item }: DeliveryPromiseComponentProps) => {
    const { t } = useGranite();

    return (
        <>
            {item.deliveryType === DeliveryType.ClickAndCollect && (
                <OrderItemStatus
                    statuses={item.orderLineStatuses}
                    deliveryType={item.deliveryType}
                />
            )}
            {item.deliveryType === DeliveryType.HomeDelivery &&
                item.transportPackageStatuses.map((status) => (
                    <Fragment
                        key={`f-${status.productSku}-${status.transportStatusMessage}`}
                    >
                        <OrderItemStatus
                            key={`status-${status.productSku}-${status.transportStatusMessage}`}
                            statuses={item.orderLineStatuses}
                            deliveryType={item.deliveryType}
                            transportStatusMessage={
                                status.transportStatusMessage
                            }
                        />
                        {status.trackAndTraceUrl && (
                            <div
                                key={`tnt-${status.productSku}-${status.transportStatusMessage}`}
                            >
                                <a href={status.trackAndTraceUrl!}>
                                    {t("general.trackAndTrace")}
                                </a>
                            </div>
                        )}
                    </Fragment>
                ))}
        </>
    );
};

export { DeliveryPromiseComponent };
